import React from 'react';
import Reveal from './Reveal';
import { photos } from '../photos';

export default function Recipes({ t }) {
  const r = t.recipes;
  const shots = [
    { src: photos.bowl, alt: t.media.bowl },
    { src: photos.chicken, alt: t.media.chicken },
    { src: photos.fresh, alt: t.media.fresh },
  ];

  return (
    <section id="recipes" className="scroll-mt-24 bg-snow py-20 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10">
        <Reveal>
          <p className="font-display text-xs tracking-[0.32em] uppercase text-voltDeep">05 — {r.kicker}</p>
          <div className="mt-4 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.92] max-w-3xl tracking-tight">
              {r.title}
            </h2>
            <p className="text-stone max-w-md leading-relaxed">{r.sub}</p>
          </div>
        </Reveal>

        <div className="mt-10 grid sm:grid-cols-3 gap-4">
          {shots.map((shot, i) => (
            <Reveal key={shot.src} delay={i * 80}>
              <figure className="relative h-72 sm:h-80 overflow-hidden bg-pine">
                <img src={shot.src} alt={shot.alt} className="w-full h-full object-cover transition-transform duration-700 hover:scale-105" />
                <figcaption className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-ink/80 to-transparent text-snow font-display uppercase tracking-wide text-xl">
                  0{i + 1}
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>

        <div className="mt-4 grid lg:grid-cols-2">
          <Reveal>
            <div className="h-full bg-ink text-snow p-8 sm:p-10">
              <h3 className="font-display text-3xl uppercase tracking-tight">{r.libraryTitle}</h3>
              <ul className="mt-6 flex flex-col">
                {r.library.map((item) => (
                  <li key={item} className="py-3 border-t border-white/15 text-snow/90">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
          <Reveal delay={80}>
            <div className="h-full bg-mist p-8 sm:p-10">
              <h3 className="font-display text-3xl uppercase tracking-tight">{r.outputTitle}</h3>
              <ul className="mt-6 grid sm:grid-cols-2 gap-3">
                {r.output.map((item) => (
                  <li key={item} className="bg-snow px-4 py-3 text-sm font-semibold border border-ink/8">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
